import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import clickShowTag from '@/components/clickShowTag.vue';
import tagModel from '@/components/tagModel.vue';
import tagList from '@/components/tagList.vue';
import { unitResource } from './../../insurance/underwritingManage/request';
import { agencyResource } from './../../insurance/organizationalManage/request';
import { customerResource } from './../../system/customerManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { downloadFileFun, LANGUAGE_RESOURCE } from '@/utils/public';
import { orderList, downloadOrder, getTags, PAYSTATUS } from './request';
import addModal from './addmodal';
import { insuranceResource } from './../../insurance/insuranceManage/request';
import moment from 'moment';
import { mapState } from 'vuex';
import { isPhone } from '@/utils/validate';
import selectShowColumn from '../../policy/customerManage/selectShowColumn.vue';
import datePicker from '@/components/datePicker.vue';
export default {
  components: {
    clickShowTag,
    tagModel,
    addModal,
    tagList,
    selectShowColumn,
    datePicker
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      PAYSTATUS,
      showItem: false,
      tagShow: false,
      form: {
        customerId: undefined,
        agencyId: undefined,
        orderCustomerId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        tags: '',
        createAt: ''
      },
      unitList: [],
      intermediaryList: [],
      customerList: [],
      customerList2: [],
      applicationList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [
        // {title: '标签', dataIndex: 'tag', key: '0', align: 'center', scopedSlots: {customRender: 'tag'}, width: 80},
        // {title: '订单号', dataIndex: 'orderNo', key: '1', align: 'center'},
        // {title: '订单来源', dataIndex: 'appName', key: '2', align: 'center'},
        // {title: '用户', dataIndex: 'userName', key: '3', align: 'center'},
        // {title: '产品名称', dataIndex: 'customerInsuranceName', key: '4', align: 'center'},
        // {title: '承保单位', dataIndex: 'unitName', key: '5', align: 'center'},
        // {title: '产品价格', dataIndex: 'totalFee', key: '6', align: 'center'},
        // {title: '订单类型', dataIndex: 'typeName', key: '7', align: 'center'},
        // {title: '订单状态', dataIndex: 'payStatusName', key: '8', align: 'center'},
        // {title: '操作', scopedSlots: {customRender: 'action'}, align: 'center', width: 100, key: '9'}
      ],
      tagData: [],
      tagList: [],
      productList: [],
      applicationTime: []
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    this.agencyFun();
    // customerResource({isLicense: 1}).then(res => {
    //   this.customerList = res;
    // });

    customerResource({}).then(res => {
      this.customerList2 = res;
      let arr = res.filter(item => item.id == Number(sessionStorage.getItem('orderCustomerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('orderCustomerId')) : res[0].id;
      sessionStorage.setItem('orderCustomerId', this.form.customerId);
      // this.form.customerId = res[0].id;
      this.getTagsFun();
      this.getDataFun();
      this.applicationFun();
    });
  },
  methods: {
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      insuranceResource({
        applicationId: this.form.applicationId,
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
    },
    getTagsFun() {
      this.tagData = [];
      this.tagList = [];
      getTags({
        customerId: this.form.customerId
      }).then(res => {
        this.tagData = res;
      });
    },
    customerChange() {
      sessionStorage.setItem('orderCustomerId', this.form.customerId);
      this.tagList = [];
      this.getTagsFun();
      this.searchFun();
      this.applicationFun();
    },
    addOrder() {
      this.$refs.addModalRef.openModal();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    agencyFun() {
      this.form.agencyId = undefined;
      let customerId = this.accountInfo.tag === 0 ? this.accountInfo.customerId : this.form.customerId; //客户传自己的customerId 中介传选择的表单归属的id
      agencyResource({
        unitId: this.form.unitId,
        customerId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
      if (!this.form.unitId) {
        this.agencyFun();
      }
    },
    applicationFun() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    applicationChange(val) {
      let arr = this.applicationList.filter(item => item.id == val);
      this.form.licenseId = arr.length != 0 ? arr[0].customerId : undefined;
      this.getInsuranceFun();
    },
    searchFun() {
      if (this.form.mobile) {
        if (!isPhone(this.form.mobile)) {
          return this.$message.error(this.$t('手机号码有误，请重新填写'));
        }
      }
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.applicationTime[0] ? moment(this.applicationTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      obj.endAt = this.applicationTime[1] ? moment(this.applicationTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      orderList(obj).then(res => {
        if (res.fieldConfig) {
          this.columns = res.fieldConfig.map(item => {
            let obj = item;
            if (item.ellipsis) {
              obj.customRender = text => h("a-tooltip", {
                "attrs": {
                  "placement": "topLeft",
                  "title": text
                }
              }, [text]);
            }
            if (item.dataIndex === 'payStatusName' || item.dataIndex === 'typeName') {
              item.customRender = (text, record) => {
                return h("span", [this.$t(text)]);
              };
            }
            if (item.dataIndex === 'tag') {
              obj.scopedSlots = {
                customRender: 'tag'
              };
            }
            return obj;
          });
          this.columns = this.columns.filter(item => item.dataIndex !== 'operate');
          this.columns.push({
            // title: '操作',
            scopedSlots: {
              customRender: 'action',
              title: 'customTitle'
            },
            align: 'center',
            class: 'column-action',
            key: 'column-action',
            width: 200
          });
        }
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    downloadFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const language = sessionStorage.getItem('locale') || 'zh_CN';
      obj.language = LANGUAGE_RESOURCE[language];
      downloadOrder(obj).then(res => {
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/vnd.ms-excel', this.$t('订单列表') + time + '.xlsx');
      });
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    },
    filterOption2(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onChange(date, dateString) {
      this.form.createAt = dateString || '';
    },
    resetFun() {
      this.tagList = [];
      this.tagShow = false;
      this.tagData = this.tagData.map(item => {
        if (item.children && item.children.length) {
          item.children = item.children.map(child => {
            delete child.choice;
            return child;
          });
          return item;
        }
      });
      this.applicationTime = [];
      this.$refs.applicationTime && this.$refs.applicationTime.resetData();
      this.form = {
        customerId: this.form.customerId,
        agencyId: undefined,
        orderCustomerId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        tags: '',
        createAt: ''
      };
    },
    onChangeTime(date) {
      this.applicationTime = date;
    },
    settingColumn() {
      this.$refs.selectShowColumn.openModal();
    }
  }
};